export default __webpack_public_path__ + "static/media/Campus_idol.888141dd.jpeg";